export default __webpack_public_path__ + "static/media/educations-highschools-applicants.699b79dc.svg";